import { Box, Flex, Text } from '@chakra-ui/react';
import EmptyState from 'src/components/Submission/BoardMemberReviewsTab/EmptyState';
import { Button } from '@morressier/alembic';
import { faCircleCheck } from '@fortawesome/pro-regular-svg-icons';
import { BrandLogo } from '../SignUpInviteSent';
import { useAuthRealm } from 'src/routes/AuthRealmAccessControl/AuthRealmContext';
import { APPLICATION_NAME } from 'src/constants';
import { replaceRedirectUrl } from '../SignIn/ResetPassword';

const AccountActivated = () => {
  const { loginUrl } = useAuthRealm();

  const handleGetStarted = () => {
    const newLoginUrl = replaceRedirectUrl(loginUrl, window.location.origin);
    window.location.href = newLoginUrl;
  };

  return (
    <Flex flexDirection="column" gap={3} px={18}>
      <BrandLogo />
      <Flex direction="column">
        <EmptyState
          title=""
          subTitle={
            <Flex
              direction={'column'}
              justifyContent={'flex-start'}
              alignItems={'flex-start'}
              textAlign={'left'}
              gap={6}
            >
              <Box>
                <Text textStyle="headingTitle">Account Activated</Text>
                <Text>
                  Congratulations! Your account is now active. You are ready to
                  join {APPLICATION_NAME}.
                </Text>
              </Box>
              <Button onClick={handleGetStarted}>Get Started</Button>
            </Flex>
          }
          bgColor="successSecondaryFill"
          icon={faCircleCheck}
          borderRadius={8}
        />
      </Flex>
    </Flex>
  );
};

export default AccountActivated;
